// React
import { createContext } from "react"

export const RestrictedUpdateContext = createContext<boolean>(false)